import { DAILY_INTERVAL, MONTHLY_INTERVAL, WEEKLY_INTERVAL } from "./constant"
import { formatNumber, toPercentage } from "../../../../helpers/numbers"
import { IntlShape } from "react-intl/src/types"

export const CHIP_TRANSLATIONS = [
	{
		interval: DAILY_INTERVAL,
		id: "phronesis.timeline.daily.option",
	},
	{
		interval: WEEKLY_INTERVAL,
		id: "phronesis.timeline.weekly.option",
	},
	{
		interval: MONTHLY_INTERVAL,
		id: "phronesis.timeline.monthly.option",
	},
]

export const getAxisLeft = (
	value: number,
	isPercentage: boolean,
	intl: IntlShape
) => {
	return isPercentage
		? toPercentage({
				value,
				intl,
				withPercentageChar: true,
		  })
		: formatNumber(value, intl)
}
